// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-action.login label.login-field {
    text-align: center;
    font-weight: normal;
    margin-bottom: 10px;
    display: block;
}`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Participant/Join.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB","sourcesContent":[".login-action.login label.login-field {\n    text-align: center;\n    font-weight: normal;\n    margin-bottom: 10px;\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
